import { BusinessStatus } from 'apollo/schema';

export const BUSINESS_STATUS_CHOICES = [
  { id: BusinessStatus.ACTIVE, name: 'Active' },
  { id: BusinessStatus.INTEGRATED, name: 'Integrated' },
  { id: BusinessStatus.DORMANT, name: 'Dormant' },
];
